/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { FlexContainer } from "@nordcloud/gnui";
import { TextBox } from "./TextBox";

type Props = {
  nextStep: () => void;
};
export function ApplicationEnvironments({ nextStep }: Props) {
  return (
    <Row justify="center">
      <Col sm={6} md={6} lg={8}>
        <Row justify="center">
          <FlexContainer justifyContent="center">
            <TextBox
              label="Add Environments"
              subLabel="Application Environments"
              wrapperStyle={{ height: "162px" }}
              disabled
            />
            <TextBox
              label="Skip Adding Environment"
              subLabel="Application Environments"
              description="The system will create default environment within your application automatically."
              wrapperStyle={{ marginLeft: "5rem" }}
              onClick={nextStep}
            />
          </FlexContainer>
        </Row>
      </Col>
    </Row>
  );
}
